import {
  Box,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
// import styles from "./CreateUser.module.css";
import ButtonCta1 from "../button/ButtonCta1";
import {
  CLIENT_ADMIN_ROLE_ID,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  toastConfig,
} from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import { ReactComponent as EditIcon } from "../../assets/images/EditSquare.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/Delete.svg";
import { v4 as uuidv4 } from "uuid";
import {
  getAllUsers,
  getUserLogin,
  updateCreatedUsers,
} from "../../reduxSlices/userSlice";
import { CustomRadio, validateEmail, validateName } from "../../helpers/helper";
import CommonDialog from "../dialog/CommonDialog";
import ContentLoader from "../loader/ContentLoader";
import { CustomTextField } from "../../helpers/helper";
import CustomAutocomplete from "../autocomplete/Autocomplete";

const service = new Service();

const CreateUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId } = useParams();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const [loader, setLoader] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [organization, setOrganization] = useState({
    organizationId: "",
    organizationName: "",
    users: [],
  });
  const [user, setUser] = useState({
    userId: "",
    emailId: "",
    familyName: "",
    givenName: "",
    isActive: true,
    isEdit: false,
    isValidEmail: false,
    isValidGivenName: false,
    isValidFamilyName: false,
    roles: [
      {
        roleId: 0,
        roleName: "",
      },
    ],
  });

  const [updateUser, setUpdateUser] = useState({
    userId: "",
    emailId: "",
    familyName: "",
    givenName: "",
    isActive: true,
    isEdit: false,
    isValidEmail: false,
    isValidGivenName: false,
    isValidFamilyName: false,
    roles: [
      {
        roleId: 0,
        roleName: "",
      },
    ],
  });

  const reverseOrganization = organization?.users;
  const headerData = useSelector((state) => state?.header);
  const buttonAction = headerData?.buttonAction;
  const addButtonDisabled = headerData?.addButtonDisabled;
  const userData = useSelector((state) => state?.user);
  const userRole = userData?.userRoleId;
  const userEmailId = userData?.emailId;
  const organisationId = userData?.organisationId;
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const allUsers = useSelector((state) => state.user.allUsers);
  const isSetupOrganisation =
    window.location.href.includes("setup-organisation");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleUserUpdateChange = (e) => {
    const { name, value } = e.target;
    setUpdateUser({ ...updateUser, [name]: value });
  };

  const handleUpdateUser = (user) => {
    const isEmailValid = validateEmail(user.emailId);
    const isGivenNameValid = validateName(user.givenName);
    const isFamilyNameValid = validateName(user.familyName);
    const role = user?.roles[0]?.roleName || "";
    setOrganization({
      ...organization,
      organizationId: user?.organization?.organizationId,
      organizationName: user?.organization?.organizationName,
    });
    setUser({ ...user, isValidEmail: isEmailValid, isValidGivenName: isGivenNameValid, isValidFamilyName: isFamilyNameValid });
    setValue(role);
  };

  const getUserData = async () => {
    const obj = {
      searchText: "",
      organizations: [],
      access: [],
      organisationId: "",
    };
    await dispatch(getAllUsers(obj));
  };

  useEffect(() => {
    setUser({
      ...user,
      roles: [
        value === "Standard"
          ? {
            roleId: 2,
            roleName: "Standard",
          }
          : {
            roleId: 1,
            roleName: "Admin",
          },
      ],
    });
  }, [value]);

  useEffect(() => {
    if (!allUsers && !userId) return;
    getUserData();
  }, [userId]);

  useEffect(() => {
    if (!allUsers && !userId) return;
    if (allUsers && userId) {
      const filterUser = allUsers.filter((user) => user.userId === userId);
      filterUser?.map((user) => handleUpdateUser(user));
    }
  }, [userId, allUsers]);

  const areInputsFilled = () => {
    if (userId) {
      return (
        organization?.organizationName &&
        user?.givenName?.trim() !== "" &&
        user?.emailId?.trim() !== ""
      );
    } else {
      return user?.givenName?.trim() !== "" && user?.emailId?.trim() !== "";
    }
  };
  const inputFilled = areInputsFilled();

  const areInputsFilledForUpdate = () => {
    return (
      updateUser?.givenName?.trim() !== "" && updateUser?.emailId?.trim() !== ""
    );
  };

  const handleInputFocus = () => {
    setIsClicked(true);
  };

  useEffect(() => {
    console.log("inputFilled>>>>", inputFilled);
    if (!userId || !isClicked) return;
    dispatch(setUpdateButtonDisabled(inputFilled));
  }, [inputFilled, isClicked]);

  useEffect(() => {
    let updatedUser = { ...user };
    if (user.emailId) {
      updatedUser.isValidEmail = validateEmail(user.emailId);
    }
    if (user.givenName) {
      updatedUser.isValidGivenName = validateName(user.givenName);
    }
    updatedUser.isValidFamilyName = validateName(user.familyName);
    setUser(updatedUser);
  }, [user.emailId, userId, user.givenName, user.familyName]);

  useEffect(() => {
    const isEmailValid = validateEmail(updateUser.emailId);
    const isGivenNameValid = validateName(user.givenName);
    const isFamilyNameValid = validateName(user.familyName);
    const updatedUsers = organization?.users?.map((user) =>
      user.userId === updateUser.userId
        ? {
          ...user,
          isValidEmail: isEmailValid,
          isValidGivenName: isGivenNameValid,
          isValidFamilyName: isFamilyNameValid
        }
        : user
    );
    setOrganization({
      ...organization,
      users: updatedUsers,
    });
  }, [updateUser.emailId, updateUser.givenName, updateUser.familyName]);

  const addUser = () => {
    if (user.isValidEmail && user.isValidGivenName && user.isValidFamilyName) {
      setIsButtonClicked(false);
      setOrganization({
        ...organization,
        users: [
          ...organization.users,
          {
            ...user,
            roles: [
              {
                roleId:
                  (organization.users.length < 1 || isAdmin) && isVfAdmin
                    ? CLIENT_ADMIN_ROLE_ID
                    : USER_ROLE_ID,
                roleName:
                  (organization.users.length < 1 || isAdmin) && isVfAdmin
                    ? "Admin"
                    : "Standard",
              },
            ],
            userId: uuidv4(),
            isValidEmail: true,
            isValidGivenName: true,
            isValidFamilyName: true
          },
        ],
      });
      dispatch(
        updateCreatedUsers({
          ...organization,
          users: [
            ...organization.users,
            {
              ...user,
              roles: [
                {
                  roleId:
                    organization.users?.length < 1 || isAdmin
                      ? CLIENT_ADMIN_ROLE_ID
                      : USER_ROLE_ID,
                  roleName:
                    organization.users?.length < 1 || isAdmin
                      ? "Admin"
                      : "Standard",
                },
              ],
              userId: uuidv4(),
            },
          ],
        })
      );
      setUser({
        userId: "",
        emailId: "",
        familyName: "",
        givenName: "",
        isActive: true,
        isEdit: false,
        // isValidEmail: false,
        roles: [
          {
            roleId: 0,
            roleName: "",
          },
        ],
      });
    } else {
      setIsButtonClicked(true);
    }
  };

  const modifyUser = (data) => {
    if (data.isValidEmail && data.isValidGivenName && data.isValidFamilyName) {
      setIsButtonClicked(false);
      const updatedUsers = organization?.users?.map((user) =>
        user.userId === data.userId
          ? {
            ...user,
            givenName: updateUser?.givenName,
            familyName: updateUser?.familyName,
            emailId: updateUser?.emailId,
            isEdit: false,
          }
          : user
      );
      setOrganization({
        ...organization,
        users: updatedUsers,
      });
      toast.success(`User details has been updated`, {
        ...toastConfig,
        style: {
          backgroundColor: "#4a67ad",
        },
      });
    } else {
      setIsButtonClicked(true);
    }
  };

  const deleteUser = (id) => {
    const updatedData = organization?.users?.filter(
      (user) => user.userId !== id
    );
    setOrganization({
      ...organization,
      users: updatedData,
    });
    dispatch(
      updateCreatedUsers({
        ...organization,
        users: updatedData,
      })
    );
    toast.success("User has been removed", {
      ...toastConfig,
      style: {
        backgroundColor: "#4a67ad",
      },
    });
  };

  const toggleAdminStatus = (data, isAdmin) => {
    const updatedUsers = organization?.users?.map((user) =>
      user.userId === data.userId
        ? {
          ...user,
          roles: [
            {
              roleId: isAdmin ? CLIENT_ADMIN_ROLE_ID : USER_ROLE_ID,
              roleName: isAdmin ? "Admin" : "Standard",
            },
          ],
        }
        : user
    );
    setOrganization({
      ...organization,
      users: updatedUsers,
    });
    toast.success(
      `${data?.givenName} has been marked as ${isAdmin ? "admin" : "standard"}`,
      {
        ...toastConfig,
        style: {
          backgroundColor: "#4a67ad",
        },
      }
    );
  };

  const toggleIsEdit = (data, name) => {
    const updatedUsers = organization?.users?.map((user) =>
      user.userId === data.userId
        ? {
          ...user,
          isEdit: name === "edit" ? true : false,
        }
        : user
    );
    setOrganization({
      ...organization,
      users: updatedUsers,
    });
  };

  useEffect(() => {
    if (organization.users?.length > 0) {
      dispatch(setAddButtonDisabled(true));
    } else {
      dispatch(setAddButtonDisabled(false));
    }
  }, [organization.users?.length]);

  useEffect(() => {
    if (isSetupOrganisation) return;
    dispatch(
      setHeader({
        page: !userId ? "add-user" : "edit-user",
        title: !userId ? "Add Users" : "Edit Users",
        subTitle: !userId
          ? !isVfAdmin
            ? "Please fill all the mandatory details to add users in your organisation"
            : "Please select the organisation and fill all the mandatory details to add users"
          : "Please update user details if there are any discrepancies",
      })
    );
    dispatch(setUpdateButtonDisabled(false));
  }, []);

  useEffect(() => {
    if (
      (buttonAction.page === "add-user" && buttonAction.action === "add") ||
      (buttonAction.page.includes("edit-user") &&
        buttonAction.action === "update")
    ) {
      handleSubmit();
    }
    if (
      (buttonAction.page === "add-user" && buttonAction.action === "cancel") ||
      (buttonAction.page.includes("edit-user") &&
        buttonAction.action === "cancel")
    ) {
      handleClickOpen();
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  useEffect(() => {
    const fetchOrganization = async () => {
      let url = `/api/Organization/OrganizationMaster`;
      const user_token = localStorage.getItem("bb_access_token");
      try {
        let data = await service.newGetApi(url, {}, user_token);
        let resp = data.data;
        console.log("resp", resp);
        setOrganizationOptions(resp);
      } catch (err) {
        console.log(err);
      }
    };
    fetchOrganization();
  }, []);

  const handleAutoCompleteChange = (name, value) => {
    setOrganization({ ...value, users: [] });
  };

  const handleGoBack = () => {
    navigate(-1);
    setOpen(false);
  };

  const handleSubmit = () => {
    if (!userId) {
      createUsers();
    } else {
      updateUsers();
    }
  };

  const handleEdit = (data) => {
    toggleIsEdit(data, "edit");
    setUpdateUser({ ...data });
  };

  const handleCancel = (data) => {
    toggleIsEdit(data, "cancel");
  };

  const handleUpdate = (data) => {
    modifyUser(data);
    // toggleIsEdit(data, "update");
  };

  const handleRadioButton = (event) => {
    setValue(event.target.value);
    setIsClicked(true);
  };

  const fetchUserLogin = async () => {
    const obj = {
      email: userEmailId,
    };
    await dispatch(getUserLogin(obj));
  };

  const createUsers = async () => {
      setLoader(true);
      let url = `/api/User/AddUsers`;
      const user_token = localStorage.getItem("bb_access_token");
      const organisationData = prepareOrganisationData();
      const formData = JSON.stringify(organisationData);
      try {
        let data = await service.newPostApi(url, formData, user_token);
        let resp = data.data;
        console.log("resp", resp);
        if (resp?.data && resp?.success) {
          setLoader(false);
          toast.success(
            `${organization?.users.length > 1
              ? `${organization?.users.length} users`
              : "New user"
            } has been added`,
            {
              ...toastConfig,
              style: {
                backgroundColor: "#4a67ad",
              },
            }
          );
          navigate("/users");
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err?.message, toastConfig);
      }
  };

  const updateUsers = async () => {
    if (user?.isValidEmail && user?.isValidGivenName && user?.isValidFamilyName) {
      setIsButtonClicked(false);
      setLoader(true);
      let url = `/api/User/UpdateUser`;
      const user_token = localStorage.getItem("bb_access_token");
      const organisationData = prepareOrganisationData();
      const formData = JSON.stringify(organisationData);
      try {
        let data = await service.newPutApi(url, formData, user_token);
        let resp = data.data;
        console.log("resp", resp);
        if (resp?.data && resp?.success) {
          toast.success("User details has been updated", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          navigate("/users");
          setLoader(false);
          fetchUserLogin();
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err?.message, toastConfig);
      }
    } else {
      setIsButtonClicked(true);
    }
  };

  const prepareOrganisationData = () => {
    if (!userId) {
      return {
        organizationId: isVfAdmin
          ? organization?.organizationId
          : organisationId,
        // organizationName: organization?.organizationName,
        users: organization?.users?.map(
          ({ isEdit, isValidEmail, isValidGivenName, isValidFamilyName, ...rest }) => rest
        ),
      };
    } else {
      return {
        userId: user?.userId,
        emailId: user?.emailId,
        familyName: user?.familyName,
        givenName: user?.givenName,
        organization: {
          organizationId: organization?.organizationId,
          organizationName: organization?.organizationName,
        },
        isActive: user?.isActive,
        roles: user?.roles,
      };
    }
  };

  const prepareData = prepareOrganisationData();

  console.log("prepareOrganisationData", prepareData);

  const getOrgLabel = (option) => option?.organizationName;

  if (loader) return <ContentLoader />;

  return (
    <>
      <div
        style={{
          borderRadius: "12px",
          backgroundColor: !isSetupOrganisation ? "#fff" : "",
          padding: !isSetupOrganisation ? "32px 0" : "",
          maxHeight: "calc(100vh - 190px)",
        }}
      >
        <Box
          component="form"
          sx={{
            "& > :not(style)": { marginBottom: "20px", width: "520px" },
          }}
          noValidate
          autoComplete="off"
        >
          {isVfAdmin && (
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <label style={labelStyle}>
                Organisation<sup style={requiredAr}>*</sup>
              </label>
              <CustomAutocomplete
                options={organizationOptions}
                value={organization}
                onChange={(e, value) => {
                  if (value === null) {
                    value = {
                      organizationId: "",
                      organizationName: "",
                    };
                  }
                  handleAutoCompleteChange("organization", value);
                }}
                getOptionLabel={getOrgLabel}
                onFocus={handleInputFocus}
                placeholder="Select organisation..."
              />
            </Box>
          )}
          {!userId &&
            ((isVfAdmin &&
              Object.keys(organization?.organizationName)?.length > 0) ||
              !isVfAdmin) && (
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <label style={labelStyle}>
                    First Name<sup style={requiredAr}>*</sup>
                  </label>
                  <CustomTextField
                    placeholder="Enter the first name..."
                    sx={{
                      width: "240px",
                      marginRight: "40px",
                      backgroundColor: isSetupOrganisation ? "#fff" : "",
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    type="text"
                    name="givenName"
                    value={user?.givenName}
                    onChange={handleUserChange}
                  />
                  {user?.givenName && !user?.isValidGivenName && isButtonClicked && (
                    <Typography
                      sx={{
                        color: "red",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: "Montserrat",
                      }}
                    >
                      Text is not valid.
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <label style={labelStyle}>Last Name (Optional)</label>
                  <CustomTextField
                    placeholder="Enter the last name..."
                    sx={{
                      width: "240px",
                      marginRight: "40px",
                      backgroundColor: isSetupOrganisation ? "#fff" : "",
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    type="text"
                    name="familyName"
                    value={user?.familyName}
                    onChange={handleUserChange}
                  />
                  {user?.familyName && !user?.isValidFamilyName && isButtonClicked && (
                    <Typography
                      sx={{
                        color: "red",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: "Montserrat",
                      }}
                    >
                      Text is not valid.
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <label style={labelStyle}>
                    Email<sup style={requiredAr}>*</sup>
                  </label>
                  <CustomTextField
                    placeholder="Enter the email..."
                    sx={{
                      width: "360px",
                      marginRight: "40px",
                      backgroundColor: isSetupOrganisation ? "#fff" : "",
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    type="text"
                    name="emailId"
                    value={user?.emailId}
                    onChange={handleUserChange}
                  />
                  {user?.emailId && !user?.isValidEmail && isButtonClicked && (
                    <Typography
                      sx={{
                        color: "red",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: "Montserrat",
                      }}
                    >
                      Email is not valid.
                    </Typography>
                  )}
                </Box>
                <Box sx={{ marginTop: "25px" }}>
                  <ButtonCta1
                    text="Add User"
                    onClick={addUser}
                    variant="outlined"
                    disabled={!inputFilled}
                    bgColor="#fff"
                    color="#f7954c"
                    width="122px"
                    height="48px"
                  />
                </Box>
              </Box>
            )}
          {userId && (
            <>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <label style={labelStyle}>
                    First Name<sup style={requiredAr}>*</sup>
                  </label>
                  <CustomTextField
                    placeholder="Enter the first name..."
                    sx={{ width: "240px", marginRight: "40px" }}
                    id="outlined-basic"
                    variant="outlined"
                    type="text"
                    name="givenName"
                    value={user?.givenName}
                    onChange={handleUserChange}
                    onFocus={handleInputFocus}
                  />
                  {user?.givenName && !user?.isValidGivenName && isButtonClicked && (
                    <Typography
                      sx={{
                        color: "red",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: "Montserrat",
                      }}
                    >
                      Text is not valid.
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <label style={labelStyle}>Last Name (Optional)</label>
                  <CustomTextField
                    placeholder="Enter the last name..."
                    sx={{ width: "240px", marginRight: "40px" }}
                    id="outlined-basic"
                    variant="outlined"
                    type="text"
                    name="familyName"
                    value={user?.familyName}
                    onChange={handleUserChange}
                    onFocus={handleInputFocus}
                  />
                  {user?.familyName && !user?.isValidFamilyName && isButtonClicked && (
                    <Typography
                      sx={{
                        color: "red",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: "Montserrat",
                      }}
                    >
                      Text is not valid.
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <label style={labelStyle}>
                  Email<sup style={requiredAr}>*</sup>
                </label>
                <CustomTextField
                  placeholder="Enter the email..."
                  sx={{ width: "520px", marginRight: "40px" }}
                  id="outlined-basic"
                  variant="outlined"
                  type="text"
                  name="emailId"
                  value={user?.emailId}
                  onChange={handleUserChange}
                  onFocus={handleInputFocus}
                />
                {user?.emailId && !user?.isValidEmail && isButtonClicked && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                    }}
                  >
                    Email is not valid.
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "end",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <label style={labelStyle}>
                    Access<sup style={requiredAr}>*</sup>
                  </label>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={value}
                      onChange={handleRadioButton}
                    >
                      <>
                        <FormControlLabel
                          // disabled
                          value="Standard"
                          control={<CustomRadio />}
                          label="Standard"
                        />
                        <Typography sx={typoStyle}>
                          Standard user can review reports based on the package
                          and data translation settings
                        </Typography>
                      </>
                      <>
                        <FormControlLabel
                          // disabled
                          value="Admin"
                          control={<CustomRadio />}
                          label="Admin"
                        />
                        <Typography sx={typoStyle}>
                          Admin can manage users, data translation settings and
                          review reports based on the package
                        </Typography>
                      </>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </>
          )}
        </Box>
        {!userId && reverseOrganization?.length > 0 && (
          <Box
            sx={{
              maxHeight: `calc(100vh - ${!isVfAdmin && !isSetupOrganisation
                ? "370px"
                : isSetupOrganisation
                  ? "540px"
                  : "485px"
                })`,
              overflowY: "auto",
              width: "100%",
            }}
            className="table_container"
          >
            <Box
              component="form"
              sx={{
                "& > :not(style)": { marginBottom: "20px", width: "520px" },
              }}
              noValidate
              autoComplete="off"
            >
              {reverseOrganization?.map((elem, i) => (
                <Box sx={{ display: "flex", flexDirection: "row" }} key={i}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <CustomTextField
                      sx={{
                        width: "240px",
                        marginRight: "40px",
                        backgroundColor: !elem.isEdit ? "#efefef" : "#fff",
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      type="text"
                      name="givenName"
                      value={
                        elem?.isEdit ? updateUser?.givenName : elem?.givenName
                      }
                      disabled={!elem.isEdit}
                      onChange={handleUserUpdateChange}
                    />
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <CustomTextField
                      sx={{
                        width: "240px",
                        marginRight: "40px",
                        backgroundColor: !elem.isEdit ? "#efefef" : "#fff",
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      type="text"
                      name="familyName"
                      value={
                        elem?.isEdit ? updateUser?.familyName : elem?.familyName
                      }
                      disabled={!elem.isEdit}
                      onChange={handleUserUpdateChange}
                    />
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <CustomTextField
                      sx={{
                        width: "360px",
                        marginRight: "40px",
                        backgroundColor: !elem.isEdit ? "#efefef" : "#fff",
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      type="text"
                      name="emailId"
                      value={elem?.isEdit ? updateUser?.emailId : elem?.emailId}
                      disabled={!elem.isEdit}
                      onChange={handleUserUpdateChange}
                    />
                    {updateUser.emailId &&
                      !elem.isValidEmail &&
                      isButtonClicked && (
                        <Typography
                          sx={{
                            color: "red",
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "Montserrat",
                          }}
                        >
                          Email is not valid.
                        </Typography>
                      )}
                  </Box>
                  {!elem.isEdit && (
                    <>
                      <Box
                        sx={{
                          marginTop: "-1px",
                          marginRight: "35px",
                          marginLeft: "-10px",
                        }}
                      >
                        <ButtonCta1
                          text={`Mark as ${elem?.roles[0]?.roleId === CLIENT_ADMIN_ROLE_ID
                            ? "Standard"
                            : "Admin"
                            }`}
                          onClick={() => {
                            setIsAdmin((prevState) => !prevState);
                            toggleAdminStatus(elem, isAdmin);
                          }}
                          variant="text"
                          disabled={false}
                          color="#f7954c"
                          width="160px"
                          height="48px"
                        />
                      </Box>
                      <Box sx={{ marginTop: "9px", marginRight: "20px" }}>
                        <EditIcon
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEdit(elem)}
                        />
                      </Box>
                      <Box sx={{ marginTop: "9px" }}>
                        <DeleteIcon
                          style={{ cursor: "pointer" }}
                          onClick={() => deleteUser(elem?.userId)}
                        />
                      </Box>
                    </>
                  )}
                  {elem.isEdit && (
                    <>
                      <Box sx={{ marginRight: "35px" }}>
                        <ButtonCta1
                          text="Update"
                          onClick={() => handleUpdate(elem)}
                          variant="outlined"
                          disabled={!areInputsFilledForUpdate()}
                          bgColor="#fff"
                          color="#f7954c"
                          width="108px"
                          height="48px"
                        />
                      </Box>
                      <Box sx={{ marginRight: "35px" }}>
                        <ButtonCta1
                          text="Cancel"
                          onClick={() => handleCancel(elem)}
                          variant="outlined"
                          disabled={false}
                          bgColor="#fff"
                          color="#f7954c"
                          width="108px"
                          height="48px"
                        />
                      </Box>
                    </>
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        )}
        {isSetupOrganisation && (
          <Box sx={{ display: "flex", paddingTop: "20px" }}>
            <Box>
              <ButtonCta1
                text="Skip"
                onClick={() => navigate("/dashboard")}
                variant="contained"
                disabled={false}
                width="83px"
                height="48px"
                color="#5a5a5a"
                bgColor="#e0e0e0"
              />
            </Box>
            <Box sx={{ marginLeft: "20px" }}>
              <ButtonCta1
                text="Continue"
                onClick={() => createUsers()}
                variant="contained"
                disabled={!addButtonDisabled}
                width="122px"
                height="48px"
              />
            </Box>
          </Box>
        )}
      </div>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleGoBack}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default CreateUser;

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};

const typoStyle = {
  fontSize: "12px",
  letterSpacing: "-0.02em",
  lineHeight: "16px",
  fontWeight: 500,
  fontFamily: "Montserrat",
  color: "#8a8a8a",
  textAlign: "left",
  display: "inline-block",
  width: "auto",
  marginLeft: "30px",
};
